module.exports = __webpack_public_path__ + "img/downloadIcon.4d0de543.svg";